import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import { Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import classNames from "classnames";
import { Fragment } from "react";
var InAppAlert = function InAppAlert(_ref) {
  var show = _ref.show,
    onClose = _ref.onClose,
    title = _ref.title,
    message = _ref.message,
    primaryCTA = _ref.primaryCTA,
    secondaryCTA = _ref.secondaryCTA,
    icon = _ref.icon,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    "aria-live": "assertive",
    className: "pointer-events-none absolute top-8 inset-0 flex items-end px-4 py-8 sm:py-6 sm:items-start sm:p-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full flex-col items-center space-y-4 sm:items-end"
  }, /*#__PURE__*/React.createElement(Transition, {
    show: show,
    as: Fragment,
    enter: "transform ease-out duration-300 transition",
    enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
    enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
    leave: "transition ease-in duration-100",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("flex pointer-events-auto w-full h-full items-stretch min-w-sm max-w-md overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-teal-600 ring-opacity-5 z-50 min-h-[80px]", _defineProperty({}, className, !!className))
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center flex-shrink-0 bg-teal-500 w-1/5"
  }, icon), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex h-full w-full p-3"
  }, !!title && /*#__PURE__*/React.createElement("p", {
    className: " font-medium text-gray-900"
  }, title), !!message && /*#__PURE__*/React.createElement("p", {
    className: "mt-1 text-gray-900"
  }, message)), (!!primaryCTA || !!secondaryCTA) && /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start items-center gap-4 ml-4 mb-3"
  }, primaryCTA, secondaryCTA)), !!onClose && /*#__PURE__*/React.createElement("div", {
    className: "m-2 flex flex-shrink-0"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Close"), /*#__PURE__*/React.createElement(XMarkIcon, {
    className: "h-5 w-5",
    "aria-hidden": "true"
  })))))));
};
export default InAppAlert;